import { CallForPapers, Committees, Home, Location, Program, Registration, SessionPage, SponsorshipPackages, Submission } from './pages';
import * as ReactDOM from "react-dom/client";
import { Route, Routes, createBrowserRouter } from "react-router-dom";


function App() {
  return (
    <Routes >
      <Route path="/"  element={<Home />}/>
      <Route path="/callforpapers"  element={<CallForPapers />}/>
      <Route path="/program"  element={<Program />}/>
      <Route path="/registration"  element={<Registration />}/>
      <Route path="/submission"  element={<Submission />}/>
      <Route path="/committees"  element={<Committees />}/>
      <Route path="/sponsorship-packages"  element={<SponsorshipPackages />}/>
      <Route path="/location"  element={<Location/>}/>
      <Route path="/program/sessions/:id" element={<SessionPage />} />
      {/* <Route path="/committees"  element={<Committees />}/> */}
    </Routes>
  );
}

export default App;
